<template>
	<div class="moAllBuildings" >
		<!--pre>{{ objGetParams }}</pre-->
		<moModuleFilter v-if="bIsObjects" @change="OnFilterApply" />

		<h6 class="mb-3 text-right">Объектов найдено: {{this.masObjects_total}}</h6>
		<h6 class="mb-3 text-center" v-if="bIsObjects && ($GVO.GetAllGet().dSearchType=='objmap') && this.masObjects_total > 1000">Ограничение отображения на карте: 1000 объектов</h6>

		

		<template v-if="bIsObjects">
			<ReSearchMObjects :masObjects="ApiData" v-model="dSearchType" @change="OnFilterApply()" />
		</template>
		<div class="row" style="align-items: center;"  v-if="bIsObjects">
			<Pagination v-if="bIsObjects && (/*typeof $GVO.GetAllGet().dSearchType != 'undefined' &&*/ $GVO.GetAllGet().dSearchType!='objmap')"
				:class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)" 
				:perPage="parseInt(c2p)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>

			<div class="d-flex" v-if="bIsObjects && (/*typeof $GVO.GetAllGet().dSearchType != 'undefined' &&*/ $GVO.GetAllGet().dSearchType!='objmap')">
				<label><p>Показывать по:</p></label>
				<el-select
					style="margin-top: -5px; width: 80px;"
					class="select-primary overflow-overlay ml-1"
					placeholder="Количество элементов на странице"
					v-model="c2p"
					@change="numberOfElements"
				>
					<el-option
						v-for="(el_opt, el_index) in c2p_options"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"
					>
					</el-option>
				</el-select>
			</div>
		</div>

	</div>
</template>
<script>
// import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import { Collapse, CollapseItem, /*TabPane, Tabs,*/  } from 'src/components';
import moModuleFilter from 'src/our_modules/MarketingModule/mo_module_filter.vue';
import Pagination from 'src/our_components/RePagination';
import ReSearchMObjects from 'src/our_modules/MarketingModule/ReSearchMObjects.vue';
import { Select, Option } from 'element-ui';

export default {
	name: 'moallbuildings-page',
	components: {
		// ReFormPrinter,
		// ReFilterBtn,
		// ReFilter,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
		moModuleFilter,
		Pagination,
		// TabPane, 
		// Tabs,
		ReSearchMObjects,
		[Option.name]: Option,
		[Select.name]: Select,
	},
	props: {
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
	},
	data() {
		return {
			ApiData: [],
			bShowFilter: false,
			objGetParams: {},
			title: '',
			masObjects_total: 0,
			count2page: 12,
			fullscreenLoading: false,
			dSearchType: 'mobj',
			bIsObjects:true,
			c2p: 10,
			c2p_options:[{'value':10,'label':'10'},{'value':20,'label':'20'},{'value':50,'label':'50'},{'value':100,'label':'100'}],
		};
	},
	watch: {
		'$route' () {
			this.getApiData(); // перенёс из OnFilterApply
		}
	},
	computed: {
		
	},
	methods: {
		getApiData(){
			this.ApiData = [];
			let filter = {};
			this.objGetParams = this.$GVO.GetAllGet();
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;
				// if(typeof this.objGetParams.c2p !='undefined')  this.objGetParams.c2p = this.c2p;
				// objItogGetParams.p=parseInt(e);

				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));	
				// console.log('filter2',filter);
			}
			
			this.$GVO.ApiCall('MyObj.GET',{flt:{...filter,...{c2p:this.c2p}}}) //,...{c2p:this.c2p} -- это для выборки по 20, 50 тп
			.then((objApi) => {
				if(objApi.success === true){
					// console.log('getApiData objApi.data',objApi.data);
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
					}
					if(objApi.total!=undefined) { 
						// this.masObjects_total=objApi.countpage;
						this.masObjects_total=objApi.total; 
					}
				}else{
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		numberOfElements(){
			// если просто применять на селекте @change="OnFilterApply", то из гет строки сотрутся все фильтры
			//console.log('numberOfElements event',e); //выбранное число

			if(this.c2p!='' && this.c2p!=undefined){
				sessionStorage.setItem('elements-prepage-number',this.c2p);
			} ///else {this.c2p=10;}

			if(this.ApiData.length < this.c2p){
				// console.log('шеф, всё пропало, объектов меньше c2p');
				this.pClick(1);
				// this.pClick(this.count2page - 1);
			}

			let strItogGetParams = '';
			let objItogGetParams = this.$GVO.GetAllGet();
			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			// strItogGetParams = 'c2p=' + e + '&' + strItogGetParams;
			// console.log('strItogGetParams event',strItogGetParams);
			this.OnFilterApply(strItogGetParams);
			this.getApiData();
		},
		OnFilterApply(strItogGetParams){ // применяет параметры из фильтра и запускает запрос к АПИ
			// console.log('OnFilterApply0',strItogGetParams);
			if(strItogGetParams == undefined){
				// var queryParams = new URLSearchParams(window.location.search);
				// history.replaceState(null, null, "?"+queryParams.toString());
				// this.objGetParams = this.$GVO.GetAllGet();

				let objItogGetParams = this.$GVO.GetAllGet();
				// let objItogGetParams = this.objGetParams; 
				
				if(typeof objItogGetParams.dSearchType !='undefined') {
						if(['mobj','lead','objmap'].indexOf(objItogGetParams.dSearchType)==-1)objItogGetParams.dSearchType = 'mobj';
					}
				if(typeof objItogGetParams.dSearchType !='undefined' && this.dSearchType != objItogGetParams.dSearchType) {
					objItogGetParams.dSearchType = this.dSearchType;
					if(typeof objItogGetParams['p'] != 'undefined'){
						delete objItogGetParams['p'];
					}
				}
				strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			}else {
				// этот блок существует, чтобы при переходе в объект и возвращении обратно ко всем объектам и применению затем фильтра нас выкидывало на 1-ю стр., 
				//иначе возможна ситуация, когда объектов меньше, чем должно быть на старой пагинации
				let objItogGetParams = this.$GVO.parseQueryString(strItogGetParams); 
				// if(this.masObjects_total< objItogGetParams['p']*this.c2p){}
				objItogGetParams['p']=1;
				strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			}
			// console.log('OnFilterApply++',strItogGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			// this.getApiData();
			
		},
		pClick(e){
			let strItogGetParams = '';
			let objItogGetParams = this.$GVO.GetAllGet();
			// this.objGetParams['p'] = parseInt(e);
			objItogGetParams.p=parseInt(e);
			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			this.$router.push({path: location.pathname+'?'+strItogGetParams}); // поменяла на прмой роутер, вместо OnFilterApply ниже, чтобы нас не перебрасывало всегда на 1 стр (доп условия из OnFilterApply).
			// this.OnFilterApply(strItogGetParams);

		},
		// OnTabChange(strTabId){
		// 	this.$emit('input', strTabId);
		// 	this.$emit('change', strTabId);
		// },
	},
	mounted() {
		let c2pFromStorage = sessionStorage.getItem('elements-prepage-number');
		if(this.dSearchType=='objmap'){
			this.c2p = '';
		}else if (c2pFromStorage!='undefined' && c2pFromStorage !='' && c2pFromStorage !=null){
			this.c2p = sessionStorage.getItem('elements-prepage-number');
		}else {this.c2p=10;}	

		var queryParams = new URLSearchParams(window.location.search);
		// queryParams.set("dSearchType", "mobj");
		history.replaceState(null, null, "?"+queryParams.toString());
		this.objGetParams = this.$GVO.GetAllGet();
		//console.log('mo_allbuildings objGetParams 150 line ',this.$GVO.unlinkObject(this.objGetParams));
		// if(typeof this.objGetParams.show_pres != 'undefined') this.showPresentation();
		this.getApiData();
	}

};
</script>
<style scoped>

.mobjectNest >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0;}
.moAllBuildings >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.moAllBuildings >>> .tab-content {margin-top: 15px;}

</style>
